import { SurveyForm } from '../../components/surveyForm/SurveyForm';
import './surveyPage.scss';

export const SurveyPage = () => {
  return (
    <div className="survey-page-container">
      <SurveyForm />
    </div>
  );
};
